import AuthForgotPassword from './ForgotPassword';

export default AuthForgotPassword;
